var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hidePricePermission)?_c('x-circular-background',{staticClass:"bg-sea-green-500",staticStyle:{"user-select":"none","cursor":"pointer"},attrs:{"padding":0.5},on:{"click":_vm.changeHide}},[_c('x-icon',{staticStyle:{"user-select":"none"},attrs:{"name":_vm.iconName,"size":24,"color":"white"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }